import React from 'react';
import { Pagination } from 'react-bootstrap';



const Paginacion = () => {

    let active = 2;
    let items = [];
    for (let number = 1; number <= 5; number++) {
        items.push(
            <Pagination.Item key={number} active={number === active} activeLabel="">
                {number}
            </Pagination.Item>,
        );
    }

    return (
        <div className="d-flex justify-content-center">
            <Pagination>{items}</Pagination>
        </div>
    )
}

export default Paginacion
